import axios from 'axios';

const getProjetos = params => axios.get('/projetos', { params });

export default {
  getProjetos,
};
